/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Card, Image, H1, Button } from '../../components';
import { BackHomeButton } from '../../components/BackHomeButton';
import { ROUTES } from '../../Constants';
import LovingIllustration from '../../assets/images/illustrations/loving.svg';

const NoMoreJobsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const MessageDiv = styled.div`
  color: gray;
  margin-bottom: 20px;
`;

export function NoMoreJobs({ history }) {
  return (
    <NoMoreJobsWrapper>
      <BackHomeButton
        onClick={() => {
          history.push(ROUTES.HOME);
        }}
      />
      <Card backgroundColor="transparent">
        <H1 fontWeight={900} margin={{ bottom: 'xs' }}>
          Thank you for your work!
        </H1>
        <MessageDiv>We have no more tasks available for now</MessageDiv>
        <Image margin="large" src={LovingIllustration} />
        <MessageDiv>Keep an eye on this job, new tasks may be available soon.</MessageDiv>
        <Button onClick={() => history.push(ROUTES.HOME)}>Go to Dashboard</Button>
      </Card>
    </NoMoreJobsWrapper>
  );
}

NoMoreJobs.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};

export default NoMoreJobs;
